var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldUnavailableFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.75001C15 12.2354 11.1775 14.9317 8.30273 15.9483C8.10659 16.0176 7.89341 16.0176 7.69727 15.9483C4.82253 14.9317 1.00004 12.2354 1 9.75001V8.99904H15V9.75001ZM7.71582 0.0420038C7.90138 -0.0133502 8.09862 -0.0133503 8.28418 0.0420038L14.2842 1.75001C14.7086 1.87669 15 2.3047 15 2.75001V5.99904H1V2.75001C1 2.3047 1.29139 1.87669 1.71582 1.75001L7.71582 0.0420038Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldUnavailableFilled);
export default __webpack_public_path__ + "static/media/shield-unavailable-filled.8dd1792260df9553812fafc6331c21a1.svg";
export { ForwardRef as ReactComponent };